import React, { memo, useEffect, useRef } from 'react';
import { Animated, Easing } from 'react-native';

const CustomExpandableView = React.memo(({ expanded = false, children }) => {
  const height = useRef(new Animated.Value(0)).current;
  const opacity = useRef(new Animated.Value(0)).current;
  const maxHeight = height.interpolate({
    inputRange: [0, 1],
    outputRange: [0, 5000], // Adjust this value to match your content's height
  });
  const duration = 600;

  useEffect(() => {
    if (expanded) {
      Animated.parallel([
        Animated.timing(height, {
          toValue: 1,
          duration: duration,
          easing: Easing.out(Easing.ease),
          useNativeDriver: false,
        }),
        Animated.timing(opacity, {
          toValue: 1,
          duration: duration,
          easing: Easing.out(Easing.ease),
          useNativeDriver: false,
        }),
      ]).start();
    } else {
      Animated.parallel([
        Animated.timing(height, {
          toValue: 0,
          duration: duration,
          easing: Easing.in(Easing.ease),
          useNativeDriver: false,
        }),
        Animated.timing(opacity, {
          toValue: 0,
          duration: duration,
          easing: Easing.in(Easing.ease),
          useNativeDriver: false,
        }),
      ]).start();
    }
  }, [expanded]);

  return (
    <Animated.View style={{ opacity: opacity, maxHeight: maxHeight, overflow: 'hidden' }}>
      {children}
    </Animated.View>
  );
});

export default CustomExpandableView;